/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
  objects: {},
  currentServiceCharge: {},
}

export const getters = {}

export const mutations = {
  SET_SERVICES_CHARGE(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
  },
  SET_SERVICE_CHARGE(state, objects) {
    state.currentChargeType = objects
  },
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getServiceCharges({ commit }) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getServiceCharges {
              servicecharges {
                id
                description
                cost
                charge_date
                client_id
              }
            }
          `,
        })
        .then(response => {
          // console.log(response)
          commit('SET_SERVICES_CHARGE', response.data.servicecharges)
          return response.data.servicecharges
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async getServiceChargeById({ commit }, { id } = {}) {
    try {
      const response = await graphqlClient.query({
        query: gql`
          query getServiceChargeById($stid: ID!) {
            serviceChargeById(id: $stid) {
              id
              description
              cost
              charge_date
              client_id
            }
          }
        `,
        variables: { stid: id },
      })
      commit('SET_SERVICE_CHARGE', response.data.serviceChargeById)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createServiceCharge({ commit, dispatch }, { charge_type, description, cost, charge_date, client_id } = {}) {
    try {
      // console.log(charge_type)
      // console.log(description)
      // console.log(chargeCost)
      // console.log(chargeDate)
      // console.log(clientId)
      await graphqlClient.mutate({
        mutation: gql`
          mutation createServiceCharge(
            $charge_type: Int, 
            $description: String, 
            $cost: Int, 
            $charge_date: String, 
            $client_id: ID
          ) {
            createServiceCharge(
              servicecharge: { 
                charge_type: $charge_type, 
                description: $description,
                cost: $cost,
                charge_date: $charge_date,
                client_id: $client_id
              }
            ) {
              id
            }
          }
        `,
        variables: {
          charge_type: charge_type,
          description: description,
          cost:  cost,
          charge_date: charge_date,
          client_id: client_id
        },
      }).then((res) => {
        dispatch('getServiceCharges')
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async updateServiceCharge({ commit, dispatch }, { id, charge_type, description, cost, charge_date, client_id } = {}) {
    try {
      await graphqlClient.mutate({
        mutation: gql`
          mutation updateServiceCharge(
            $stid: Int!
            $charge_type: Int
            $description: String
            $cost: Int
            $charge_date: String
            $client_id: ID) {
            updateServiceCharge(
              id: $stid
              charge: { 
                charge_type: $charge_type, 
                description: $description,
                cost: $cost,
                charge_date: $charge_date,
                client_id: $client_id,
              }
            ) {
              id
            }
          }
        `,
        variables: {
          stid: id,
          charge_type: charge_type,
          description: description,
          cost:  cost,
          charge_date: charge_date,
          client_id: client_id
        },
      })
      dispatch('getServiceCharges')
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async deleteServiceCharge({ commit }, { id } = {}) {
    try {
      // let that = this
      const response = await graphqlClient.mutate({
        mutation: gql`
          mutation deleteServiceCharge($stid: Int!) {
            deleteServiceCharge(id: $stid) {
              id
            }
          }
        `,
        variables: { stid: id },
      })
      commit('SET_SERVICES_CHARGE', response.data.deleteServiceCharge)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
}
